import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { saveItem } from '../../app/common/libs/localstorage';
import {
  fetchProducts,
  checkoutSession,
  fetchCancelSubscription,
  fetchUpdatePlan,
  getProductById,
} from './PaymentAPI';

const initialState = {
  plans: { data: [], error: '', loading: false },
  checkout: { data: [], error: '', loading: false },
  cancelSubs: { data: [], error: '', loading: false },
  updatePlan: { data: [], error: '', loading: false},
  planByName: { data: [], error: '', loading: false },
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPlanError: (state, action) => {
      state.planByName.error = action.payload;
    },
  },
  extraReducers: {
    [fetchProducts.pending]: (state) => {
      // console.log('fetchPlans pending state => ', state.plans);
      state.plans.loading = true;
    },
    [fetchProducts.rejected]: (state, action) => {
      // console.log('fetchPlans rejected state => ', state.plans);
      state.plans.loading = false;
      state.checkout.loading = false;
      state.cancelSubs.loading = false;
      state.updatePlan.loading = false;
      state.plans.data = [];
      state.plans.error = action.payload?.Errors
        ? action.payload.Errors.join(',')
        : 'Network Error';
    },
    [fetchProducts.fulfilled]: (state, action) => {
      // console.log('fetchPlans fulfilled state => ', state.plans);
      state.plans.loading = false;
      state.plans.error = '';
      state.plans.data = action.payload;
      state.checkout.loading = false;
      state.cancelSubs.loading = false;
      state.updatePlan.loading = false;
    },
    [checkoutSession.pending]: (state) => {
      console.log('checkOut state => ', state);
      state.checkout.loading = true;
    },
    [checkoutSession.rejected]: (state, action) => {
      state.checkout.loading = false;
      state.checkout.data = [];
      state.checkout.error = action.payload;
      // console.log('action.payload ==> ', action.payload);
      toast.error(action.payload);
    },
    [checkoutSession.fulfilled]: (state, action) => {
      state.checkout.loading = false;
      state.checkout.error = '';
      state.checkout.data = action.payload;
    },
    [fetchCancelSubscription.pending]: (state) => {
      state.cancelSubs.loading = true;
    },
    [fetchCancelSubscription.rejected]: (state, action) => {
      state.cancelSubs.loading = false;
      state.cancelSubs.data = [];
      state.cancelSubs.error = action.payload?.Errors
        ? action.payload.Errors.join(',')
        : 'Network Error';
    },
    [fetchCancelSubscription.fulfilled]: (state, action) => {
      state.cancelSubs.loading = false;
      state.cancelSubs.error = '';
      state.cancelSubs.data = action.payload;
      // toast.success(`Plan Successfully Unsubscribed...!`);
    },
    [fetchUpdatePlan.pending]: (state) => {
      state.updatePlan.loading = true;
    },
    [fetchUpdatePlan.rejected]: (state, action) => {
      state.updatePlan.loading = false;
      state.updatePlan.data = [];
      state.updatePlan.error = action.payload?.Errors
        ? action.payload.Errors.join(',')
        : 'Network Error';
    },
    [fetchUpdatePlan.fulfilled]: (state, action) => {
      state.updatePlan.loading = false;
      state.updatePlan.error = '';
      state.updatePlan.data = action.payload;
      toast.success(`Plan Updated Successfully...!`);
    },
    [getProductById.pending]: (state) => {
      state.planByName.loading = true;
    },
    [getProductById.rejected]: (state, action) => {
      state.planByName.loading = false;
      state.checkout.loading = false;
      state.cancelSubs.loading = false;
      state.updatePlan.loading = false;
      state.planByName.data = [];
      state.planByName.error = action.payload?.Errors
        ? action.payload.Errors.join(',')
        : action.payload;
    },
    [getProductById.fulfilled]: (state, action) => {
      state.planByName.loading = false;
      state.planByName.error = '';
      state.planByName.data = action.payload;
      saveItem('planData', state.planByName.data);
      state.checkout.loading = false;
      state.cancelSubs.loading = false;
      state.updatePlan.loading = false;
    },
  },
});

export const {
  setPlanError
} = paymentSlice.actions;
export default paymentSlice.reducer;
